module.exports = __webpack_public_path__ + "media/images/promo-holidays-160-7db82298a41854ce6632990718ec9a7e.jpg";